import Vue from "vue";
import VuePageTitle from "vue-page-title";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Validators } from "@/utils/validators.js"; 
import NProgress from "vue-nprogress";
import AxiosApiService from "./services/axios";
import VueLayers from "vuelayers";
import BootstrapVue from "bootstrap-vue";
import VuePapaParse from 'vue-papa-parse'


import {
  Avatar,
  TreeSelect,
  Rate,
  Breadcrumb,
  InputNumber,
  Steps,
  Message,
  Upload,
  Button,
  Layout,
  Table,
  Icon,
  Progress,
  Radio,
  Dropdown,
  Menu,
  Carousel,
  Input,
  Calendar,
  Badge,
  Slider,
  Form,
  Tooltip,
  Select,
  Switch,
  Tag,
  Affix,
  Spin,
  Alert,
  Checkbox,
  Tabs,
  Pagination,
  notification,
  Drawer,
  Cascader,
  DatePicker,
  TimePicker,
  Divider,
  Anchor,
  AutoComplete,
  BackTop,
  Collapse,
  Card,
  List,
  Popover,
  Tree,
  Timeline,
  Row,
  Col,
  Transfer,
  Modal,
  message,
  Popconfirm,
  Skeleton
} from "ant-design-vue";
import vSelect from "vue-select";

import "./filters";

import "./global.scss";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";

import storeConfig from "./store/system";

// install rules
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

extend('cpf', {
  getMessage: field => 'The ' + field + ' value is not valid cpf number.',
  validate: value => Validators.validateCPF(value)
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.use(BootstrapVue);
Vue.use(VueLayers);
Vue.use(Skeleton);
Vue.use(Avatar);
Vue.use(Popconfirm);
Vue.use(Transfer);
Vue.use(Modal);
Vue.use(Divider);
Vue.use(Row);
Vue.use(Col);
Vue.use(Timeline);
Vue.use(Tree);
Vue.use(Popover);
Vue.use(List);
Vue.use(Card);
Vue.use(Button);
Vue.use(Rate);
Vue.use(TreeSelect);
Vue.use(Breadcrumb);
Vue.use(Layout);
Vue.use(Table);
Vue.use(Icon);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Carousel);
Vue.use(Input);
Vue.use(Calendar);
Vue.use(Badge);
Vue.use(Slider);
Vue.use(Form);
Vue.use(Tooltip);
Vue.use(Select);
Vue.use(Tag);
Vue.use(Affix);
Vue.use(Spin);
Vue.use(Alert);
Vue.use(Checkbox);
Vue.use(Tabs);
Vue.use(Pagination);
Vue.use(Upload);
Vue.use(Message);
Vue.use(Steps);
Vue.use(InputNumber);
Vue.use(Drawer);
Vue.use(Switch);
Vue.use(Cascader);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Anchor);
Vue.use(AutoComplete);
Vue.use(Collapse);
Vue.use(BackTop);
Vue.use(VuePapaParse);
Vue.component("v-select", vSelect);
Vue.prototype.$notification = notification;
Vue.prototype.$message = message;
Vue.prototype.$unmaskMoney =  (value) => {
  return (
    parseInt(
      (value + "")
        .replace(/R\$/gi, "")
        .replace(/\s/gi, "")
        .replace(/\./gi, "")
        .replace(/,/gi, "")
    ) / 100
  );
};

// editor de textos
import VueQuillEditor from "vue-quill-editor";

import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)


Vue.use(VueQuillEditor /* { default global options } */);
// editor de textos

const baseTitle = "%title% | ";
Vue.use(NProgress);
Vue.use(AxiosApiService);
Vue.use(VuePageTitle, {
  prefix: baseTitle,
  setTitleMethod: title => {
    try {
      const configs = storeConfig.state.config;
      if (configs.name) {
        title = title.replace(baseTitle, `${configs.name} | `);
      } else {
        throw "No title defined";
      }
    } catch (e) {
      title = title.replace(`${baseTitle} `, "");
    }
    document.title = title;
  },
  router
});

Vue.config.productionTip = false;
const nprogress = new NProgress({ parent: "body" });

new Vue({
  router,
  store,
  nprogress,
  render: h => h(App)
}).$mount("#app");
